import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

export const submitContactInquiry = async (data) => {
  const res = await client.post("/contact", { ...data, source: "contact_page" });
  return res.data;
};

export const submitCallbackRequest = async (data) => {
  const res = await client.post("/callback", { ...data, source: "cta_callback" });
  return res.data;
};

export default client;
